// User-related util functions
import store from 'store';

export const getFacilityDetails = (id) => {
  const { facilitiesV2 } = store.getState();
  return facilitiesV2.dropdown[id];
};
